export const gstAdjusted = (amount, gst) => {
  const base = Number(amount) || 0;
  if (!gst?.included) return base;
  const rate = Number(gst?.rate) || 0;
  return base * (1 + rate / 100);
};

export const computeTotal = ({ primaryCharge, serviceCharge, extraCharges }, gst) =>
  gstAdjusted(primaryCharge, gst?.primaryChargeGst) +
  gstAdjusted(serviceCharge, gst?.serviceChargeGst) +
  gstAdjusted(extraCharges, gst?.extraChargesGst);

export const computeFinalAmount = (charges, gst, discount) =>
  computeTotal(charges, gst) - (Number(discount) || 0);

export const chargeBreakdown = (charges, gst, discount) => {
  const primaryCharge = gstAdjusted(charges?.primaryCharge, gst?.primaryChargeGst);
  const serviceCharge = gstAdjusted(charges?.serviceCharge, gst?.serviceChargeGst);
  const extraCharges = gstAdjusted(charges?.extraCharges, gst?.extraChargesGst);
  const total = primaryCharge + serviceCharge + extraCharges;
  const discountAmount = Number(discount) || 0;
  return {
    primaryCharge,
    serviceCharge,
    extraCharges,
    total,
    discount: discountAmount,
    finalAmount: Math.max(total - discountAmount, 0),
  };
};

export const DEFAULT_GST_RATE = "10";

export const defaultGstSetting = (included) => ({ included, rate: DEFAULT_GST_RATE });
